/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, September 22nd 2021, 11:44:01 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

export const TRANSLATIONS_EN = {
  Edit: "Edit",
  Delete: "Delete",
  "Deploy Service": "Deploy Service",
  Home: "Home",
  Organizations: "Organizations",
  Portals: "Portals",
  "Workflow Marketplace": "Workflow Marketplace",
  "Service Templates": "Service Templates",
  Teams: "Teams",
  Users: "Users",
  Groups: "Groups",
  Departments: "Departments",
  "Account Settings": "Account Settings",
  Billing: "Billing",
  Logout: "Logout",
  Organization: "Organization",
  "Choose an Organization": "Choose an Organization",
  "Organization Setup": "Organization Setup",
  "Portals Setup": "Portals Setup",
  "Invite Workers": "Invite Workers",
  "Billing Details": "Billing Details",
  "General Details": "General Details",
};
